import { Application, Loader } from '@goodboydigital/astro';
import { lerp } from '@goodboydigital/odie';
import gsap from 'gsap';
import { Container, Graphics, Sprite, Texture } from 'pixi.js';

import { App } from '../App';
import { MenuClouds } from '../ui/MenuClouds';
import { Random } from '../utils/Random';

export class LoadingScreen implements Loader
{
    private _app: App;
    readonly centreHeight = 768 / 2;
    public view: Container;
    private _loadingBg: Sprite;
    private _loadingBar: Sprite;
    private _loadingMask: Graphics;
    private _progress: number;
    
    constructor(app: Application)
    {
        this._app = app as App;
        this.view = new Container();
        this._progress = 0;
        
        this._app.createMenuClouds();

        this._loadingBg = new Sprite(Texture.from('loading-empty.png'));
        this._loadingBg.anchor.set(0.5);
        this._loadingBg.y = this.centreHeight;
        this.view.addChild(this._loadingBg);

        this._loadingBar = new Sprite(Texture.from('loading-full.png'));
        this._loadingBar.anchor.set(0.5);
        this._loadingBar.y = this.centreHeight;
        this.view.addChild(this._loadingBar);

        this._loadingMask = new Graphics();
        this._loadingMask.beginFill(0xFF0000, 0);
        this._loadingMask.drawRect(
            0, 0,
            this._loadingBar.width,
            this._loadingBar.height,
        );
        this._loadingMask.position.set(-this._loadingBar.width / 2, -this._loadingBar.height / 2);
        this._loadingBar.addChild(this._loadingMask);
        this._loadingBar.mask = this._loadingMask;
        this.view.addChild(this._loadingMask);
    }

    updateProgress(value: number): void
    {
        if (value > 1) value = value / 100;
        this._progress = value;
    }

    async show(): Promise<void>
    {
        this._app.clouds?.show();
        
        this._progress = 0;
        this._loadingMask.scale.x = 0;
        this.view.alpha = 0;
        gsap.to(this.view, { alpha: 1, duration: 0.2, ease: 'linear' });
    }

    async hide(): Promise<void>
    {
        await gsap.to(this.view, { alpha: 1, duration: 0.4, ease: 'linear' });
    }

    update(delta: number): void
    {
        this._app.clouds?.update(delta);

        this._loadingMask.scale.x = lerp(this._loadingMask.scale.x, this._progress, 0.25 * delta);
    }

    resize(w: number, h: number): void
    {
        this._loadingBg.x = w / 2;
        this._loadingBg.y = (h / 2) + (this._loadingBg.height / 2);
        this._loadingBar.x = w / 2;
        this._loadingBar.y = this._loadingBg.y;
        this._loadingMask.position.set(
            this._loadingBg.x - (this._loadingBar.width / 2),
            this._loadingBg.y - (this._loadingBar.height / 2),
        );

        this._app.clouds?.resize(w, h);
    }
}
